import * as themes from './themes';

function loadTheme() {
  return process.env.REACT_APP_THEME ? themes[process.env.REACT_APP_THEME] : themes.defaultTheme;
}

export const theme = loadTheme();
